import type { ChatConversation, ChatMessage } from '@/types/chat';

const BASE = '/api/v1/chat';

async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(path, { credentials: 'include', ...options });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error ?? `HTTP ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function fetchConversations(status = 'active'): Promise<ChatConversation[]> {
  const data = await apiFetch<{ ok: boolean; data: ChatConversation[] }>(
    `${BASE}/conversations?status=${status}`
  );
  return data.data;
}

export async function fetchMessages(conversationId: string): Promise<ChatMessage[]> {
  const data = await apiFetch<{ ok: boolean; data: ChatMessage[] }>(
    `${BASE}/conversations/${conversationId}/messages`
  );
  return data.data;
}

export async function archiveConversation(conversationId: string): Promise<void> {
  await apiFetch(`${BASE}/conversations/${conversationId}/archive`, { method: 'POST' });
}

export async function unarchiveConversation(conversationId: string): Promise<void> {
  await apiFetch(`${BASE}/conversations/${conversationId}/unarchive`, { method: 'POST' });
}

export async function markConversationRead(conversationId: string): Promise<void> {
  await apiFetch(`${BASE}/conversations/${conversationId}/read`, { method: 'POST' });
}
